import { Fulfillment } from "@secondcloset/types";

import { getAPIFromDomain } from "../../lib/api";

type ResourceError = Fulfillment.ResourceError;
interface FetchResourceErrorsIndexQuery {
  id?: string;
  resource_id?: string;
  resource_type?: string;
  assignee?: string;
  page?: number;
  per_page?: number;
}
export interface ResourceErrorIndex {
  data: ResourceError[];
  meta: {
    active_error_count: number;
    count: number;
    current_page: number;
    total_entries: number;
    total_pages: number;
  };
}

export const fetchResourceErrorsIndex = async (query: FetchResourceErrorsIndexQuery): Promise<ResourceErrorIndex> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/resource_errors/index`;
  const response = await api.get(url, {
    params: query,
  });
  return response.data;
};

interface AssignResourceErrorPayload {
  resource_id: string;
  body: { assigned_user_id: string };
}
export const assignResourceError = async ({
  resource_id,
  body,
}: AssignResourceErrorPayload): Promise<ResourceError> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/resource_errors/${resource_id}`;
  const response = await api.put(url, { attributes: body });
  return response.data;
};
